import { render, staticRenderFns } from "./GiveGiftCountDown.vue?vue&type=template&id=55882990&scoped=true"
import script from "./GiveGiftCountDown.vue?vue&type=script&lang=js"
export * from "./GiveGiftCountDown.vue?vue&type=script&lang=js"
import style0 from "./GiveGiftCountDown.vue?vue&type=style&index=0&id=55882990&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55882990",
  null
  
)

export default component.exports